import { borderBox, dflexJustifyCenter, footerBtn, footerSection } from '../../../assets/styles/css-classes';
import CssVariables from '../../../assets/styles/css-variables';
import { makeStylesV5 } from '../../index';
export default makeStylesV5()(() => ({
    childSection: Object.assign(Object.assign({}, borderBox), { flex: 1, height: 'calc(100% - 40px)' }),
    tabsRoot: {
        '& .cf-tabs-indicator': {
            height: 5
        },
        '& .cf-matrix-tab': {
            textTransform: 'inherit',
            fontSize: 14,
            color: '#222222',
            '&.Mui-selected': {
                backgroundColor: '#F5F5F5',
                color: CssVariables.primaryMain,
                fontSize: 12,
                fontWeight: 600,
            },
        }
    },
    tabHeader: {
        display: 'flex',
        borderBottom: '1px solid #DEDEDE',
    },
    tabPanel: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        height: 'calc(100% - 48px)',
        overflow: 'hidden',
        '& .panelContainer': {
            display: 'flex',
            flex: 1,
            height: '100%',
            overflow: 'hidden',
            '& .tabPanelHeader': {
                display: 'flex',
                height: 34,
                justifyContent: 'space-between',
                paddingLeft: 17,
                paddingRight: 8,
            },
            '& .cf-matrix-tab-panel-divider': {
                marginTop: 5,
                marginBottom: 5,
                height: 0,
            },
            '& .gridSection': {
                margin: 10,
                height: 'calc(100% - 40px)',
                overflow: 'hidden',
                '& .MuiDataGrid-cell:first-of-type': {
                    borderRight: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiTableContainer-root': {
                    height: '100%',
                    overflowY: 'auto'
                }
            },
        },
    },
    backButton: {
        borderRadius: 0,
        margin: 0,
        fontSize: 17,
        color: '#222222',
    },
    gridMatrix: {
        flex: 1,
        width: '100%'
    },
    formButtonSection: Object.assign(Object.assign({}, footerSection), dflexJustifyCenter),
    formButton: Object.assign({}, footerBtn),
    basicTable: {
        border: 0,
        borderCollapse: 'unset',
        '& .tableHeadRow': {
            '& .cf-table-cell-row': {
                color: '#222222',
                fontSize: 13,
                fontWeight: 600,
                textAlign: 'center',
                backgroundColor: CssVariables.columnHeader,
                width: 250,
            },
            '& .cf-table-cell-row:first-of-type': {
                borderRight: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'left',
                position: 'sticky',
                left: 0,
                zIndex: 5,
            }
        },
        '& .basicTableBody': {
            '& .cf-matrix-row-table-cell': {
                padding: '5px 15px',
                width: '20%',
                textAlign: 'center',
                font: 'normal normal normal 13px/19px Open Sans',
                borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                '& .subtableTypography': {
                    '& .description': {
                        color: '#888888',
                        font: 'normal normal normal 12px/18px Open Sans',
                    }
                }
            },
            '& .MuiTableCell-body': {
                textAlign: 'center',
                [`&:first-of-type`]: {
                    minWidth: 250,
                    textAlign: 'left',
                    borderRight: '1px solid #F5F5F5',
                    position: 'sticky',
                    backgroundColor: '#fff',
                    left: 0,
                    zIndex: 2,
                },
            },
            '& .sub-permission': {
                '& .cf-matrix-row-sub-permission-cell:first-of-type': {
                    borderLeft: '30px solid #F5F5F5',
                }
            },
            '& .tableRow:last-child': {
                '& .tableCell': {
                    borderBottom: '0px'
                }
            }
        }
    }
}));
//# sourceMappingURL=styles.js.map